import React from "react";
import { Heading, Text, Link } from "spectacle";
import Button from '../components/Button';

const Contact = () =>
    <div>
        <Heading size={5} textColor="fifth" caps>
            Let's talk
        </Heading>
        <Text margin="10 0 0 0" textColor="primary" textSize={50}>
            <Link textColor="quarternary" style={{ textDecoration: "none" }} href="mailto:hi@altola.co">hi@altola.co</Link>
        </Text>
        <Button targetUrl='https://altola.co/contact' title="Contact Us" />
    </div>

export default Contact;


// WEBPACK FOOTER //
// ./src/slides/Contact.js